export const ENVIRONMENT = window.ENVIRONMENT || window.ENVIROMENT;

// Public marketing site (landing). Used by the web/PWA "Volver al sitio" CTA.
export const PORTAL_URL = window.PORTAL_URL || 'https://www.montepio.org.mx';

// SAP consumer origin sent to the backend to identify the caller (paymentId prefix
// and SAP user/branch). Default is APP; PORTAL is used when the app runs embedded
// inside the web portal.
export const SAP_CONSUMER_ORIGIN = Object.freeze({ APP: 1, PORTAL: 2 });

export const ENVIRONMENT_TYPE = Object.freeze({
  PRODUCTION: 'pro',
  PREPRODUCTION: 'pre',
  STAGING: 'staging',
  DEVELOPMENT: 'dev',
});

export const PHONE_MEXICO_CONTRY_CODE = '+52';
export const PHONE_EEUU_CONTRY_CODE = '+1';

export const ROLES = Object.freeze({
  ADMIN: 'ADMIN',
  USER: 'USER',
});

export const TIMEZONE = -6;
